/* eslint-disable */
import React from "react";
import { Button } from "@material-ui/core";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetfilter } from "../../../../common/video/VideoFilterActions";
import { RecommendVideo } from "../../../../common/homePage/model/HomePage";
import useResponsive from "../../../../common/useResponsive";

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    tag: {
      marginRight: "10px",
      cursor: "pointer",
      borderRadius: "4px",
      backgroundColor: "#ffffff",
      color: "#00538A",
      boxShadow: "none",
      margin: "3px 1px",
      fontSize: "16px",
      lineHeight: "24px",
      border: "2px solid #00538A",
      fontWeight: "bold",
      "&:hover": {},
    },
    mobileTag: {
      fontSize: "14px",
    }
  })
);

interface TagListProps {
  videoList: RecommendVideo[];
}

function TagList({ videoList }: TagListProps) {
  const classes = useStyles();
  const history = useNavigate();
  const dispatch = useDispatch();
  const { isMobile } = useResponsive()

  // ビデオリストから重複しないタグリストを洗い出す
  let tags: string[] = [];
  for (const video of videoList) {
    tags = tags.concat(video.tags);
  }
  tags = Array.from(new Set(tags));

  const handleClick = (tagName: string) => {
    const videoFilter = {
      id: [],
      professional: [],
      program: [],
      project: [],
      tag: [tagName],
    };
    dispatch(resetfilter(videoFilter));
    setTimeout(() => history("/videos"), 100);
  };

  return (
    <>
      {tags.map((tag, index) => (
        <Button
          key={`${index}`}
          size="medium"
          variant="contained"
          className={`${classes.tag} ${isMobile && classes.mobileTag}`}
          style={{ padding: "3px 9px" }}
          onClick={() => handleClick(tag)}
        >
          {tag}
        </Button>
      ))}
    </>
  );
}

export default TagList;
